import { END_POINTS } from '../helpers';
import { GccData, CommonBody } from '../types/General';
import emptySplitApi from '../utils/rtk';

type CommonResponse = {
  statusCode: number;
  message: string;
};

type GetGccResponse = {
  count: number;
  data: GccData[];
};

export const gccApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getGcc: builder.query<
      CommonResponse & { data: GetGccResponse },
      {
        page: number;
        limit: number;
        search: string;
        vehicleId?: string;
      }
    >({
      query: ({ page, limit, search, vehicleId }) => ({
        url: `${END_POINTS.getGcc}?page=${page}&limit=${limit}${
          search?.length ? `&search=${search}` : ''
        }${vehicleId ? `&vehicleId=${vehicleId}` : ''}`,
        method: 'GET',
      }),
    }),

    deleteGcc: builder.query<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteGcc}/${id}`,
        method: 'DELETE',
      }),
    }),
    getGccById: builder.query<CommonResponse & { data: GccData }, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.getGccById}/${id}`,
        method: 'GET',
      }),
    }),

    addGcc: builder.mutation<CommonResponse & { data: GccData }, { body: CommonBody }>({
      query: ({ body }) => ({
        url: `${END_POINTS.addGcc}`,
        method: 'POST',
        body,
      }),
    }),
    updateGcc: builder.mutation<
      CommonResponse & { data: GccData },
      { body: CommonBody; id: string | undefined }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateGcc}/${id}`,
        method: 'PUT',
        body,
      }),
    }),
  }),
});

export const {
  useAddGccMutation,
  useUpdateGccMutation,
  useLazyGetGccQuery,
  useLazyDeleteGccQuery,
  useLazyGetGccByIdQuery,
} = gccApi;
